import { isAxiosError, type AxiosResponse } from 'axios';
import * as Sentry from '@sentry/vue';
import type { Router } from 'vue-router';
import { axiosInstance } from './client';

const APPLICATION_ROUTE_NAME_PREFIX = 'application.';
const APPLICATION_SERVER_ERROR_ROUTE_NAME = 'application.server-error';

const handledServerErrors = new WeakSet<object>();

export const isHandledApplicationServerError = (error: unknown): boolean =>
    typeof error === 'object' && error !== null && handledServerErrors.has(error);

export const isInsideApplicationFlow = (router: Router): boolean => {
    const name = router.currentRoute.value.name;
    return (
        typeof name === 'string' &&
        name.startsWith(APPLICATION_ROUTE_NAME_PREFIX) &&
        name !== APPLICATION_SERVER_ERROR_ROUTE_NAME
    );
};

export const handleApplicationServerErrorResponse = (error: unknown, router: Router): boolean => {
    if (!isAxiosError(error) || error.response?.status !== 500 || !isInsideApplicationFlow(router)) {
        return false;
    }
    handledServerErrors.add(error);
    Sentry.captureException(error);
    void router.push({ name: APPLICATION_SERVER_ERROR_ROUTE_NAME });
    return true;
};

export const setupApplicationServerErrorInterceptor = (router: Router): void => {
    axiosInstance.interceptors.response.use(
        (response: AxiosResponse) => response,
        (error: unknown) => {
            handleApplicationServerErrorResponse(error, router);
            return Promise.reject(error);
        }
    );
};
